import React from 'react';
import * as yup from "yup";
import PropTypes from "prop-types";
import { yupResolver } from "@hookform/resolvers/yup";
import { Col, Row } from 'react-styled-flexboxgrid';
import Button from '../../components/Button';
import ButtonGroup from '../../components/ButtonGroup';
import Divider from '../../components/Divider';
import Form from '../../components/Form';
import FormLabel from '../../components/FormLabel';
import Icon from '../../components/Icon';
import Paper from '../../components/Paper';
import Typography from '../../components/Typography';
import useTheme from '../../hooks/useTheme';
import JobShortDesc from '../../pages/Dashboard/components/JobShortDesc';
import { makeStyles } from '../../utils/styles';
import { useForm } from 'react-hook-form';
import TextArea from '../../components/TextArea';
import Banner from '../../components/Banner';
import User from '../../components/User';
import Loader from '../../components/Loader';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((css) => ({
    paper: css`
        position: relative;
        overflow: hidden;
        padding: 30px 30px 15px 30px;
        width: 680px;
    `,
    dividerHeader: css`
        margin-top: 25px;
        margin-bottom: 20px;
    `,
    divider: css`
        margin-top: 10px;
        margin-bottom: 20px;
    `,
    subTypography: css`
        ${({ theme }) => theme.fonts.mulishRegular};
        font-size: 11px;
        color: ${({ theme }) => theme.colors.dimGrey};
    `,
    textArea: css`
        margin-bottom: 15px;
    `
}));

const schema = yup.object().shape({
    message: yup.string(),
});

const FormJobDeleteCandidate = ({ loading, job, candidate, onClickCancel, onSubmit }) => {
    const { t } = useTranslation()
    const styles = useStyles();
    const theme = useTheme();

    const { register, handleSubmit, errors } = useForm({
        resolver: yupResolver(schema),
    });

    return (
        <Paper
            customStyle={styles.paper}
        >
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Typography as="h1">
                    {t("Usuń kandydata")}
                </Typography>
                <Divider customStyle={styles.dividerHeader} />
                <User
                    user={candidate}
                    showRating
                />
                <Divider customStyle={styles.divider} />
                <FormLabel>{t("Zlecenie, do którego zgłosił się kandydat")}</FormLabel>
                <JobShortDesc job={job} />
                <Banner>
                    <Typography color="inherit">
                        {t("Jeśli usuwasz kandydata, możesz podać mu powód Twojej decyzji.")}
                    </Typography>
                </Banner>
                <TextArea
                    ref={register}
                    name="message"
                    label={t("Wiadomość")}
                    placeholder={t("Opcjonalnie")}
                    error={!!errors.message}
                    errorText={errors.message?.message}
                    fullWidth
                    height={120}
                    customStyle={styles.textArea}
                />
                <Row end="xs">
                    <Col>
                        <ButtonGroup>
                            <Button
                                variant="text"
                                onClick={onClickCancel}
                                startIcon={
                                    <Icon
                                        name="close"
                                        width={12}
                                        height={12}
                                        fill={theme.colors.purple}
                                    />
                                }
                            >
                                {t("ANULUJ")}
                            </Button>
                            <Button
                                type="submit"
                                startIcon={
                                    <Icon name="delete" width={12} height={12} fill={theme.colors.white} />
                                }
                                disabled={loading}
                            >
                                {t("USUŃ KANDYDATA")}
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </Form>
            <Loader show={loading} />
        </Paper>
    );
};

FormJobDeleteCandidate.propTypes = {
    loading: PropTypes.bool,
    candidate: PropTypes.object,
    job: PropTypes.object,
    onSubmit: PropTypes.func,
    onClickCancel: PropTypes.func,
};

export default FormJobDeleteCandidate;
